/**
 *新增 add
 *编译 edit
 *查看 view
 */
export const DATA_TYPE_STATUS = {
  add: 'add',
  edit: 'edit',
  view: 'view'
}
/**案件类型key */
export const CASE_TYPE_KEY = 'caseTypeKey'
/**填报表单key */
export const CASE_DETAIL_KEY = Symbol('td-penalize-detail-Key')
/**数据来源 */
export const DATA_SOURCE_TYPE = [
  {
    label: '填报系统',
    value: '1'
  },
  {
    label: '统建系统',
    value: '2'
  },
  {
    label: '数据对接',
    value: '3'
  },
  {
    label: '历史数据',
    value: '4'
  }
]
/**环保法典启用日期 */
export const CIVIL_ENV_CODE_DATE = 'CIVIL_ENV_CODE_DATE'
/**案件线索来源禁用代码 */
export const PENALIZE_CLUE_SOURCE_DISABLED = 'PENALIZE_CLUE_SOURCE_DISABLED'
/**案件类型显示 */
export const PUNISH_ENABLE_CASE_TYPE = 'PUNISH_ENABLE_CASE_TYPE'


